<template>
	<div>
		<el-form :model="form" ref="form" labelPosition="right" autoComplete="on" labelWidth="120px">
			<el-form-item prop="subbrandId" label="品牌：" :rules="[{required: true, trigger: 'blur', message: '请选择品牌'}]">
				<el-select v-model="form.subbrandId" filterable placeholder="请选择品牌" style="width:650px;" clearable>
					<el-option v-for="item in config_data['brands']" :key="item.code" :label="item.name" :value="item.code"></el-option>
				</el-select>
			</el-form-item>
			<!-- <el-form-item prop="mobiles" label="发送客户：" v-if="type != 'edit'" :rules="[{required: true, trigger: 'blur', message: '请选择客户'}]">
				<el-input v-model="form.mobiles" disabled placeholder="请点击选择发送客户" style="width:560px;"></el-input>
				<el-divider direction="vertical"></el-divider>
				<el-button @click.stop="handleSelectCustomer" icon="el-icon-thumb" type="text" size="mini"> 选择客户</el-button>
			</el-form-item> -->
			<el-form-item prop="customers" label="发送客户：" :rules="[{required: true, trigger: 'blur', message: '请选择客户'}]">
				<el-select v-model="form.customers" filterable placeholder="请选择客户批次" style="width:650px;" clearable>
					<el-option v-for="item in customerList" :key="item.customerBatchNo" :label="item.remark + ' - ' + item.customerBatchNo" :value="item.customerBatchNo"></el-option>
				</el-select>
				<!-- <el-input v-model="form.mobiles" disabled placeholder="请点击选择发送客户" style="width:560px;"></el-input> -->
				<!-- <el-divider direction="vertical"></el-divider> -->
				<!-- <el-button @click.stop="handleSelectCustomer" icon="el-icon-thumb" type="text" size="mini"> 选择客户</el-button> -->
			</el-form-item>
			<!-- <el-form-item prop="sendNum" label="发送条数：" v-if="type != 'edit'">
				<el-input v-model="form.sendNum" disabled placeholder="选择客户后展示" style="width:650px;"></el-input>
			</el-form-item> -->
			<el-form-item prop="configId" label="短信账号：" :rules="[{required: true, trigger: 'blur', message: '请选择短信账号'}]">
				<el-select v-model="form.configId" filterable placeholder="请选择短信账号" style="width:650px;" clearable>
					<el-option v-for="item in sms_account" :key="item.configId" :label="item.configName" :value="item.configId"></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item prop="templetId" label="短信模板：">
				<el-select v-model="form.templetId" filterable :disabled="!form.subbrandId" placeholder="请选择短信模板" style="width:650px;" clearable>
					<el-option v-for="item in sms_template" :key="item.templetId" :label="item.name" :value="item.templetId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="smsBody" label="短信内容：" :rules="[{required: true, trigger: 'blur', message: '请输入短信内容'}]">
				<el-input v-model="form.smsBody" ref="singleText" :rows="4" type="textarea" placeholder="请输入短信内容" style="width:650px;" clearable></el-input>
			</el-form-item>
			<!-- <el-form-item prop="remark" label="备注：">
				<el-input v-model="form.remark" placeholder="请输入备注" style="width:650px;" maxlength="11" show-word-limit clearable></el-input>
			</el-form-item> -->
			<el-form-item prop="scheduleTime" label="预约发送时间：">
				<el-date-picker
					:picker-options="setDisabledDate"
					v-model="form.scheduleTime"
					type="datetime"
					:clearable="false"
					value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="请选择预约发送时间"  style="width:650px;">
				</el-date-picker>
			</el-form-item>
			<el-divider></el-divider>
			<el-form-item style="float: right;padding-right: 30px;">
				<el-button v-if="type == 'edit'" @click.stop="handleCancelSingle" :loading="loading" size="mini" type="danger" plain>取消预约</el-button>
				<el-button @click.stop="handleSave" :loading="loading" size="mini" type="primary">发 送</el-button>
			</el-form-item>
		</el-form>
		<el-drawer 
			title="客户信息导入"
			:visible.sync="dialogVisibleCustomer"
			:wrapperClosable="false"
			:append-to-body="true"
			:modal-append-to-body="false"
			size="510px"
			direction="rtl">
			<CustomerImport v-if="dialogVisibleCustomer" @onEmitCustomerData="onEmitCustomerData" />
		</el-drawer>
	</div>
</template>

<script>
import CustomerImport from './CustomerImport';
export default {
	props: ['type', 'itemData', 'listQuery'],
	components: {CustomerImport},
	computed: {
		setDisabledDate() {
			return {
				disabledDate(time){
					let now = new Date();
					now.setDate(now.getDate() - 1);
					now.setHours(now.getHours());
					now.setMinutes(now.getMinutes());
					now.setSeconds(now.getSeconds());
					return time < now;
				}
			}
		}
	},
	data() {
		return {
			dialogVisibleCustomer: false,
			loading: false,
			form: {
				subbrandId: '',
				customers: '',
				mobiles: '',
				sendNum: '',
				configId: '',
				templetId: '',
				smsBody: '',
				remark: '',
				scheduleTime: '',
			},
			config_data: {
				brands: [],
				suppliers: []
			},
			sms_account: [],
			sms_template: [],
			flag: 0,
			customerList: []
		}
	},
	watch: {
		'form.customers': {
			handler(val) {
				if(val) {
					for(const item of this.customerList) {
						if(item.customerBatchNo == val) {
							this.form.sendNum = item.sendNum;
						}
						
					}
				}
				
			},
			deep: true
		},
		'form.subbrandId': {
			handler(val) {
				if(val) {
					this.getTemplateData();
				}
			}
		},
		'form.templetId': {
			handler(val) {
				if(val) {
					if(this.flag == 0) {
						return;
					}
					this.$api.apiPostSmsGetTemplateBody({templetId: val}).then(response => {
						if(response.errcode != 0) return;
						this.form.smsBody = response.data.templetBody;
						this.form.scheduleTime = this.form.scheduleTime ? dayjs(this.form.scheduleTime).format('YYYY-MM-DD HH:mm:ss') : '';
					});
				}
			}
		}
	},
	async created() {
		await this.getConfigData();
		await this.getAccountData();
		await this.getCustomerBatchList();
		if(this.type == 'edit') {
			// this.$api.apiPostSmsSelectSmsGroupDetails({
				
			// }).then(response => {
			// 	console.log(response)
			// });
			this.form = Object.assign(this.form, this.itemData);
			this.form.subbrandId = this.form.brand;
		} else {
			this.form.configId = this.listQuery.configId;
		}
		setTimeout(() => {
			this.flag = 1;
		}, 500);
	},
	methods: {
		getCustomerBatchList() {
			this.$api.apiPostSmsImportLogList({
				pageNum: 1,
				pageSize: 999,
				status: 'done'
			}).then(response => {
				if(response.errcode != 0) return;
				this.customerList = response['list'];
			});
		},
		handleSave() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.$api.apiPostSmsSaveSmsGroup(this.form).then(response => {
						if(response.errcode != 0) return;
                        this.$notify({
                            title: "提交成功",
                            offset: 70,
                            type: "success"
                        });
						this.loading = false;
						this.$emit('closeDialogFormVisible', true);
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		resetForm() {
			this.form = {
				subbrandId: '',
				customers: '',
				mobiles: '',
				sendNum: '',
				configId: '',
				templetId: '',
				smsBody: '',
				remark: '',
				scheduleTime: '',
			}
			if (this.$refs["form"]) {
				this.$refs["form"].clearValidate();
			}
		},
		getConfigData() {
			this.$api.apiPostSmsConfigData().then(response => {
				if(response.errcode != 0) return;
				this.config_data = Object.assign(this.config_data, response.data);
			});
		},
		getAccountData() {
			this.$api.apiPostSmsConfigList().then(response => {
				if(response.errcode != 0) return;
				this.sms_account = response.data['configList'];
			});
		},
		getTemplateData() {
			this.$api.apiPostSmsCascadeTemplateList({
				subbrandId: this.form.subbrandId
			}).then(response => {
				if(response.errcode != 0) return;
				this.sms_template = response.data['templetList'];
				
			});
		},
		handleCancelSingle() {
			const self = this;
			self.$confirm('是否取消此次预约', '系统提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'error',
			}).then(() => {
				self.$api.apiPostSmsDeleteSmsGroup({id: this.form.id}).then(response => {
					if(response.errcode != 0) return;
					self.$message({
						message: "取消成功",
						type: "success"
					});
					self.$emit('closeDialogFormVisible', true);
				});
			}).catch(() => {});
		},
		handleSelectCustomer() {
			this.dialogVisibleCustomer = true;
		},
		onEmitCustomerData(data) {
			this.form.mobiles = data.mobiles;
			this.form.sendNum = data.sendNum;
			this.form.customers = data.customerBatchNo;
			this.dialogVisibleCustomer = false;
		}
	}
}
</script>
